import { Partner, PartnerCompany, PartnerType } from "@/data/actions-query";

export const isVGEPartner = (partner: { subtype?: PartnerCompany | null }) => {
  return partner.subtype === PartnerCompany.vge;
};
export const isLocalPartner = (partner: { subtype?: PartnerCompany | null }) => {
  return partner.subtype === null;
};
export const isAcegPartner = (partner: { subtype?: PartnerCompany | null }) => {
  return partner.subtype === PartnerCompany.aceg;
};
export const isInpressPartner = (partner: { subtype?: PartnerCompany | null }) => {
  return partner.subtype === PartnerCompany.inpress;
};

export const vgePartnerTypes = [PartnerType.vgEEpc, PartnerType.vgEEk, PartnerType.vgEAsbestos, PartnerType.vgEFuelOilTank, PartnerType.vgEImmoSigns];
